import {Injectable} from '@angular/core';
import {AuthenticationService} from './authentication.service';
import {Constants} from '../constants';

@Injectable()
export class AccessService {

  constructor(private authService: AuthenticationService) {
  }

  canAccessOIA(): boolean {
    if (this.authService.isLoggedIn() === true) {
      for (let i = 0; i < JSON.parse(localStorage.getItem('epas_user')).roles.length; i++) {
        if (JSON.parse(localStorage.getItem('epas_user')).roles[i].hasOwnProperty('role_name') &&
            JSON.parse(localStorage.getItem('epas_user')).roles[i]['role_name'] === 'OIA' ) {
          return true;
        }
      }
    }
    return false;
  }

  canAccessOutgoingStudent(): boolean {
    if (this.authService.isLoggedIn() === true) {
      for (let i = 0; i < JSON.parse(localStorage.getItem('epas_user')).roles.length; i++) {
        if (JSON.parse(localStorage.getItem('epas_user')).roles[i].hasOwnProperty('role_name') &&
            JSON.parse(localStorage.getItem('epas_user')).roles[i]['role_name'] === Constants.OUTGOING_STUDENT) {
          return true;
        }
      }
    }
    return false;
  }

  canAccessPOC(): boolean {
    if (this.authService.isLoggedIn() === true) {
      for (let i = 0; i < JSON.parse(localStorage.getItem('epas_user')).roles.length; i++) {
        if (JSON.parse(localStorage.getItem('epas_user')).roles[i].hasOwnProperty('role_name') &&
            JSON.parse(localStorage.getItem('epas_user')).roles[i]['role_name'] === Constants.POC) {
          return true;
        }
      }
    }
    return false;
  }

  canAccessIncomingStudent(): boolean {
    if (this.authService.isLoggedIn() === true) {
      for (let i = 0; i < JSON.parse(localStorage.getItem('epas_user')).roles.length; i++) {
        if (JSON.parse(localStorage.getItem('epas_user')).roles[i].hasOwnProperty('role_name') &&
            JSON.parse(localStorage.getItem('epas_user')).roles[i]['role_name'] === Constants.INCOMING_STUDENT) {
          return true;
        }
      }
    }
    return false;
  }

  canAccessEC(): boolean {
    if (this.authService.isLoggedIn() === true) {
      for (let i = 0; i < JSON.parse(localStorage.getItem('epas_user')).roles.length; i++) {
        if (JSON.parse(localStorage.getItem('epas_user')).roles[i].hasOwnProperty('role_name') &&
            JSON.parse(localStorage.getItem('epas_user')).roles[i]['role_name'] === 'EC') {
          return true;
        }
      }
    }
    return false;
  }
}
